import {
    PriceContainer,
    PriceDataContainer,
    SkeletonAddBasket,
    SkeletonContainer,
    SkeletonDescriptionGoodSection,
    SkeletonFullTitle,
    SkeletonImageContainer,
    SkeletonInfoContainer,
    SkeletonTextInfoLong,
    SkeletonTextInfoSmall
} from './good-item-container.styled'
import { SkeletonPlaceholder } from 'src/shared/ui/skeleton/skeleton.styled'

export function GoodItemSkeletonDesktop() {
    return (
        <SkeletonContainer>
            <SkeletonImageContainer>
                <SkeletonPlaceholder />
            </SkeletonImageContainer>
            <SkeletonDescriptionGoodSection>
                <SkeletonInfoContainer>
                    <SkeletonFullTitle>
                        <SkeletonPlaceholder />
                    </SkeletonFullTitle>
                    <SkeletonTextInfoLong>
                        <SkeletonPlaceholder />
                    </SkeletonTextInfoLong>
                    <SkeletonTextInfoSmall>
                        <SkeletonPlaceholder />
                    </SkeletonTextInfoSmall>
                </SkeletonInfoContainer>
            </SkeletonDescriptionGoodSection>
            <PriceContainer>
                <PriceDataContainer>
                    <SkeletonAddBasket>
                        <SkeletonPlaceholder />
                    </SkeletonAddBasket>
                </PriceDataContainer>
            </PriceContainer>
        </SkeletonContainer>
    )
}
